  <template>
    <div>
      <b-tabs v-model="activeTab" type="is-toggle" position="is-centered">

        <b-tab-item label="Lista de grupos" icon="stream" icon-pack="fas">

          <div class="flex flex-col">
            <div class="top-bar flex justify-end">
              <v-button @click="addGroup" icon="plus" class="ml-4" :disabled="showFormLinkGroup">{{
                $t('add_group') }}</v-button>

              <v-button @click="exportGroups" icon="file-export" class="ml-4 bg-green-dark"
                :disabled="showFormData || showFormLinkGroup">{{ $t('export') }}</v-button>
            </div>

            <div
              :class="[( showFormData || showFormLinkGroup ? 'w-7/12' : 'w-full'), 'mr-2', 'mt-2']">
              <activity-groups-list ref="list_groups" :entity-type="entityType" :entity-id="projectId"
                :disabled-menu-actions="showFormData || showFormLinkGroup"
                @add-group="handleAddGroup" @edit-group="handleEditGroup" @link-group="handleLinkGroup"
                @drop-group="handleDropGroup"></activity-groups-list>
            </div>

            <!-- Modals -->
            <activity-group-edit-modal ref="refEditModal"
              :entity-type="entityType"
              :entity-id="projectId"
              @epc-success-creating="handleSuccess"/>

            <activity-group-link-modal ref="refLinkModal"
              :project-id="projectId"
              :entity-type="entityType"
              @epc-success-link="() => { $ref.refLinkModal.hide() }"/>
          </div>
        </b-tab-item>

        <!-- Aquí puedes agregar más pestañas en el futuro -->
        <b-tab-item :label="$t('import')" icon="file-import" icon-pack="fas">
          <div class="w-full">
            <import-entities :can-overwrite="true"
              :project-id="projectId"
              :withHistory="false"
              :entity-type="'activity-groups'"
              :morph-type="entityType"
              @success="() => { $refs.list_groups.reload() }"
            />
          </div>
        </b-tab-item>

        <b-tab-item :label="$t('configurations')" icon="cog" icon-pack="fas">
          <activity-groups-config :project-id="projectId" />
        </b-tab-item>
      </b-tabs>
    </div>
  </template>

<script>
import Form from "vform";
import axios from "axios";
import ActivityGroupsList from './activity-groups-list.vue';
import ActivityGroupEditModal from './components/edit-modal.vue';
import ActivityGroupsImport from './activity-groups-import.vue';
import ActivityGroupsConfig from './activty-groups-config.vue';
import ImportEntities from '../../components/import-entities';
import ActivityGroupLinkModal from './components/link-modal.vue';

export default {
  name: "manage-groups-activities",

  components: {
    ActivityGroupsList,
    ActivityGroupEditModal,
    ActivityGroupLinkModal,
    ActivityGroupsImport,
    ActivityGroupsConfig,
    ImportEntities,
  },

  data: () => ({
    group: null, // objeto que se crea
    showFormData: false,
    showFormLinkGroup: false,
    groups: [], // unidades de la compania
    showModal: false,
    activeTab: 0,
  }),

  props: {
    projectId: { type: Number, required: true },
    entityType: { type: String, required: true } // el entityType para el componente activity groups import pasa a ser el morphType
  },

  computed: {
  },

  created() {
    this.getGroups()
  },

  mounted() {
  },

  methods: {
    async getGroups() {
      this.groups = []

      const {data} = await axios.get('/api/v2/project/'+ this.projectId + '/activity/groups', {params: { full_tree: 1 }}) // gestión necesita la jerarquía completa
      if (data && data.success) {
        this.groups = data.groups
      }
      // else
      //   error_retreving_group_info
    },

    async exportGroups() {
      const {data} = await axios.get('/api/v2/export/activity-groups', {
        params: {
          projectable_id: this.projectId,
          projectable_type: 'project',
        }
      })
      if (data && data.success) {
        const url = data.url
        window.open(url, '_blank')

        this.$notify.success('success_exporting_groups')
      }
    },

    addGroup() {
      this.group = null
      // this.showFormData = true;
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
      // this.showFormData = true;
    },


    handleOnCloseEdit(event) {
      this.showFormData = !event
    },

    handleSuccess(entity) { // recibe la entidad editada
      this.showFormData = false
      this.$refs.list_groups.reload()
      this.$refs.refEditModal.hide(); // Cierra el modal de edición
    },

    // handleEditEntity(entity) {
    //   this.entity = entity
    //   this.showFormData = true;
    // },

    handleAddGroup(group) {
      this.group = group
      // this.showFormData = true;
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
    },

    handleEditGroup(group) {
      this.group = group
      this.$refs.refEditModal.show(this.group); // Resetea el formulario del modal
      // this.showFormData = true;
    },

    handleLinkGroup(group) {
      this.group = group
      // this.showFormLinkGroup = true
      this.$refs.refLinkModal.show(this.group);
    },

    async handleDropGroup(group) {
      let form = new Form({
        id: group.id,
        entity_type: this.entityType,
        parent_id: group.parent_id === group.id ? null : group.parent_id,
        code: group.code,
        name: group.name,
        weight: group.weight,
        color: group.color,
        order_column: group.order_column,

      })

      let url = `/api/v2/activity/groups/${group.id}`; // se edita el grupo

      const { data } = await form.post(url).catch((error) => { console.log(error) })

      if (data && data.success) {

        this.$notify.success('success_editing')

        if( data.warning )
          this.$notify.warning(data.warning)
        this.handleSuccess();
      } else {
        this.processingData = false
        if( data && data.message )
          this.$notify.error(data.message)
        else
          this.$notify.error('error_creating_group')
      }
    },
  }

};
</script>

<style scoped>
</style>
